<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Changes</h3>
    <div class="dialog-header__title">
      <i class="icon-close" (click)="closeModal()"></i>
    </div>
  </div>
  <div class="value">
    <div class="value__labels">
      <div class="value__label">Old value</div>
      <div class="value__label mt-16">New value</div>
    </div>
    <app-table
      [content]="valueArr"
      [headers]="headers"
      [tableType]="'material'"
      [isSortTable]="false"
    ></app-table>
  </div>
</div>
